import { ConfigProvider } from "antd";
import React from 'react';

/**
 * Color class with Marsh graphic charter
 */
export class Color {
    static darkBlue(opacity = 1) {
        // "#002C77"
        return `rgba(0, 44, 119, ${opacity})`;
    }

    static blue(opacity = 1) {
        // "#009DE0"
        return `rgba(0, 157, 224, ${opacity})`;
    }

    static lightBlue(opacity = 1) {
        // "#76D3FF"
        return `rgba(118, 211, 255, ${opacity})`;
    }

    static white(opacity = 1) {
        // "#FFFFFF"
        return `rgba(255, 255, 255, ${opacity})`;
    }

    static teal(opacity = 1) {
        // "#0077A0"
        return `rgba(0, 119, 160, ${opacity})`;
    }

    static turquoise(opacity = 1) {
        // "#00968F"
        return `rgba(0, 159, 143, ${opacity})`;
    }

    static green(opacity = 1) {
        // "#00AC41"
        return `rgba(0, 172, 65, ${opacity})`;
    }

    static blueGray(opacity = 1) {
        // "#8096B2"
        return `rgba(128, 150, 178, ${opacity})`;
    }

    static lightTeal(opacity = 1) {
        // "#9CD9E4"
        return `rgba(156, 217, 228, ${opacity})`;
    }

    static gray(opacity = 1) {
        // "#949494"
        return `rgba(148, 148, 148, ${opacity})`;
    }

    static darkGray(opacity = 1) {
        // "#565656"
        return `rgba(86, 86, 86, ${opacity})`;
    }

    static yelloow(opacity = 1) {
        // "#FFBE00"
        return `rgba(255, 190, 0, ${opacity})`;
    }

    static orange(opacity = 1) {
        // "#FF8C00"
        return `rgba(255, 140, 0, ${opacity})`;
    }

    static crimson(opacity = 1) {
        // "#EF4E45"
        return `rgba(239, 78, 69, ${opacity})`;
    }

    static pink(opacity = 1) {
        // "#EE3D8B"
        return `rgba(238, 61, 139, ${opacity})`;
    }

    static purple(opacity = 1) {
        // "#8246AF"
        return `rgba(130, 70, 175, ${opacity})`;
    }
}

interface ThemeProps {
    children: any;
}

const ThemeProvider: React.FC<ThemeProps> = ({children}) => {
    return (
        <ConfigProvider
            theme={{
                token: {
                    colorPrimary: Color.darkBlue(),
                    colorBgLayout: Color.white(),
                }
            }}>
            {children}
        </ConfigProvider>
    );
}
export default ThemeProvider;
